module.exports = "/images/apartments.svg?9217d44eff4c742a6786750e03343527";